import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Chart: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size + 1}
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 8.293l3.146-3.147.708.708L5 10.207.646 5.854l.708-.708L4.5 8.293V0h1v8.293z"
        fill={color}
      />
    </svg>
  );
};

export default Chart;
